const body = document.querySelector('body');
const focusClass = 'kb-focus';
let added = false;

const removeClassOnNextMousedown = () => {
	if (added) {
		return;
	}
	const handler = () => {
		body.classList.remove(focusClass);
		added = false;
	};
	window.addEventListener('mousedown', handler, { once: true });
	added = true;
};

window.addEventListener('keydown', e => {
	if (e.key === 'Tab') {
		body.classList.add(focusClass);
		removeClassOnNextMousedown();
	}
});
